import { createEpic } from "../helpers";

import {
	getRulesListAsyncAction,
	updateRuleAsyncAction,
	postRuleAsyncAction,
	deleteRuleAsyncAction,
	getRuleDetailAsyncAction,
} from "./rulesActions";

export const getRulesListEpic = createEpic(
	getRulesListAsyncAction,
	"rules",
	"getRulesList",
	true
);

export const getRuleDetailEpic = createEpic(
	getRuleDetailAsyncAction,
	"rules",
	"getRuleDetail",
	true
);

export const putRuleEpic = createEpic(
	updateRuleAsyncAction,
	"rules",
	"putRule",
	true
);

export const postRuleEpic = createEpic(
	postRuleAsyncAction,
	"rules",
	"postRule",
	true
);

export const deleteRuleEpic = createEpic(
	deleteRuleAsyncAction,
	"rules",
	"deleteRule",
	true
);
